(function () {
  pagination(true);
})();
